// extracted by css-extract-rspack-plugin
export default {"popupLabel":"emptyLink-module__popupLabel___VUoIL","popupParent":"emptyLink-module__popupParent___mt3Mp"};